//farmerImage
import vijaySingh from '../assets/farmerImage/vijay_singh.png';
import kishor from '../assets/farmerImage/kishor.png';
import Image from 'next/image';

import weather_unit_1 from '../assets/icon/kairo_1.jpg';
import weather_unit_2 from '../assets/icon/kairo_2.png';
import weather_unit_3 from '../assets/icon/kairo_3.png';

export const WeatherImageArray = [
  {
    text: 'weather unit 1',
    image: weather_unit_1,
  },
  {
    text: 'weather unit 2 ',
    image: weather_unit_2,
  },
  {
    text: 'weather unit 3',
    image: weather_unit_3,
  },
];

export default function WeatherSlider(text, image) {
  return (
    <div className="w-full h-full grid place-items-center">
      <Image
        className="w-full h-full object-contain rounded-md"
        src={image}
        alt={text}
        sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
      />
    </div>
  );
}

export const WeatherSliderArray = WeatherImageArray.map((weatherImage) => {
  return WeatherSlider(weatherImage.text, weatherImage.image);
});
